function HeaderMenuButton({ open, onClick, labelOpen, labelClose }) {
  return (
    <button
      type="button"
      className="header__menu-btn"
      aria-label={open ? labelClose : labelOpen}
      aria-expanded={open}
      onClick={onClick}
    >
      <span />
      <span />
      <span />
    </button>
  )
}

export default HeaderMenuButton
